export default {"src":"/manage-assets/_next/static/media/create-promo-dark.8e624f05.svg","height":175,"width":263,"blurWidth":0,"blurHeight":0};